import {ProductsActions} from "../../reducers/products/ActionsNames";

export default function () {
 return {
   type: ProductsActions.LoadProducts
 }
}